<template>
  <div
    v-if="showModal"
    class="modal d-block"
    style="background: rgba(0, 0, 0, 0.5)"
    @click.self="$emit('close')"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Rate This Post</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        <div class="modal-body">
          <div class="rating-section text-center">
            <p class="text-muted mb-3">Click stars to rate this post</p>
            <div class="rating-stars">
              <i
                v-for="star in 5"
                :key="star"
                class="bi rating-star"
                :class="star <= (hoverRating || currentRating) ? 'bi-star-fill active' : 'bi-star'"
                @click="setRating(star)"
                @mouseover="hoverRating = star"
                @mouseleave="hoverRating = 0"
              ></i>
            </div>
            <div class="rating-text mt-3">
              <span v-if="currentRating > 0" class="selected-rating">{{ currentRating }}/5 stars</span>
              <span v-else class="text-muted">No rating selected</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Cancel
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            @click="submitRating"
            :disabled="currentRating === 0 || isSubmitting"
          >
            <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
            {{ isSubmitting ? 'Submitting...' : 'Submit Rating' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    post: {
      type: Object,
      default: null
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'submit'],
  data() {
    return {
      currentRating: 0,
      hoverRating: 0
    }
  },
  methods: {
    setRating(rating) {
      this.currentRating = rating
    },

    submitRating() {
      if (this.currentRating === 0) return

      this.$emit('submit', {
        post: this.post,
        rating: this.currentRating,
        review: '' // No review text - rating only
      })
    },

    resetForm() {
      this.currentRating = 0
      this.hoverRating = 0
    }
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script>

<style scoped>
.modal-content {
  border-radius: 15px;
}

.modal-header {
  border-bottom: 1px solid #eee;
  padding: 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #eee;
  padding: 1.5rem;
}

/* Rating Modal */
.rating-section {
  padding: 2rem 0;
}

.rating-stars {
  font-size: 3rem;
  color: #dee2e6;
  margin: 1.5rem 0;
}

.rating-star {
  cursor: pointer;
  margin: 0 0.5rem;
  transition: all 0.3s ease;
}

.rating-star:hover,
.rating-star.active {
  color: #ffc107;
  transform: scale(1.1);
}

.rating-text {
  font-size: 1.2rem;
  font-weight: 600;
}

.selected-rating {
  color: #ffc107;
  font-size: 1.3rem;
}

.btn {
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
</style>